import { useEffect } from 'react';

import styles from './styles.module.css';

export const useTheme = (isDark: boolean) => {
    useEffect(() => {
        window.document.documentElement.classList.add(styles.root)        
    }, [])
    useEffect(() => {
        if (isDark) {
            window.document.documentElement.classList.remove(styles.light)
            window.document.documentElement.classList.add(styles.dark)
        } else {
            window.document.documentElement.classList.remove(styles.dark)
            window.document.documentElement.classList.add(styles.light)
        }
    }, [isDark])
}
